/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { DtpContentContainer } from 'dtp-react-components';
import { Button } from '../../components';
import {
  doGet,
} from '../../utils/requests';
import FiltroExtratoCnis from './FiltroExtratoCnis';

class ConsultaExtratoCnis extends Component {
  constructor() {
    super();
    const initialState = this.getInitialState();
    this.state = initialState;
  }

  getInitialState = () => ({
    listaExtratoCnis: [],
    filtrosPesquisa: {},
    showNoContent: false,
    noContentPrimaryMessage: 'Json de retorno não encontrado para o nit informado.',
    noContentSecondaryMessage: 'Informe um nit válido.',
    exibirBotaoSelecionarTudo: false,
  })

  montaFiltros = (atributosPesquisa) => {
    let atributos = [];
    if (atributosPesquisa.nitCnis) {
      atributos = { ...atributos, nitFiltro: atributosPesquisa.nitCnis };
    }
    if (atributosPesquisa.elosCnis) {
      atributos = { ...atributos, elosFiltro: atributosPesquisa.elosCnis };
    }
    return atributos;
  }

  realizaConsulta = (filtrosPesquisa) => {
    let filtrosConsulta = {};
    if (filtrosPesquisa) {
      filtrosConsulta = this.montaFiltros(filtrosPesquisa);
    }
    this.setState({ filtrosConsulta }, this.executaConsulta);
  }

  // handleSearch = () => {
  //   let paramNit = '';
  //   let paramElos = '';
  //   if (this.state.nitCnis) {
  //     paramNit = this.state.nitCnis;
  //   }
  //   if (this.state.elosCnis) {
  //     paramElos = this.state.elosCnis;
  //   }
  //   const parametros = {
  //     nitFiltro: paramNit,
  //     elosFiltro: paramElos,
  //   };
  //   this.buscarJsonExtratoCnis(parametros);
  // }

  // buscarJsonExtratoCnis = () => {
  //   const url = 'integracao/extrato-cnis';
  //   // doPost(url, parametros, this.handleSucessBuscarNitElos);
  //   doGet(url, this.handleSucessBuscarNitElos, this.handleErrorBuscarNitElos, parametros);
  // }

  executaConsulta = () => {
    if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      doGet(
        'integracao/extrato-cnis',
        this.handleSucessBuscarNitElos,
        this.handleErrorBuscarNitElos,
        this.state.filtrosConsulta,
      );
    }
  }

  handleErrorBuscarNitElos = () => {
  };

  // buscarJsonExtratoCnis = (parametros) => {
  //   const url = 'integracao/extrato-cnis';
  //   // doPost(url, parametros, this.handleSucessBuscarNitElos);
  //   doGet(url, this.handleSucessBuscarNitElos, this.handleErrorBuscarNitElos, parametros);
  // }

  preparaRequest = (urlRelatorio, parametros, callback) => {
    doGet(
      urlRelatorio,
      parametros,
      callback,
      this.tratarErro,
    );
  }

  handleSucessBuscarNitElos = (response) => {
    if (response.data) {
      const jsonRetorno = document.getElementById('jsonRetorno');
      const obj = JSON.parse(response.data.json);
      jsonRetorno.innerHTML = JSON.stringify(obj, undefined, 2);
      // this.setState({ listaExtratoCnis: [response.data.json] });
      this.setState({ exibirBotaoSelecionarTudo: true });
    }
  }

  selecionarTudo = (element) => {
    const doc = document;
    const text = doc.getElementById(element);
    if (doc.body.createTextRange) {
      const range = doc.body.createTextRange();
      range.moveToElementText(text);
      range.select();
    } else if (window.getSelection) {
      const selection = window.getSelection();
      const range = doc.createRange();
      range.selectNodeContents(text);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  copiarParaAreaDeTransferencia = (element) => {
    const doc = document;
    const text = doc.getElementById(element);
    const selection = window.getSelection();
    const range = doc.createRange();
    range.selectNodeContents(text);
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand('copy');
  }

  render() {
    return (
      <DtpContentContainer>
        <FiltroExtratoCnis
          handleSearchFilter={this.realizaConsulta}
        />
        { this.state.exibirBotaoSelecionarTudo &&
          <div className="row">
            <Button
              className="dtp-button left"
              onClick={() => this.copiarParaAreaDeTransferencia('jsonRetorno')}
              hint="Copiar o conteúdo do JSON para a área de transferência."
              mini
              icon="ico-doc-copy"
            />
          </div>
        }
        <div style={{ paddingTop: this.state.exibirBotaoSelecionarTudo ? '0px' : '20px' }}>
          <pre
            style={{
            paddingTop: '20px',
            backgroundColor: '#ffffff',
            // height: '400px',
            // 'overflow-y': 'auto',
            }}
            id="jsonRetorno"
          />
        </div>
      </DtpContentContainer>
    );
  }
}

ConsultaExtratoCnis.propTypes = { };

export default ConsultaExtratoCnis;



// WEBPACK FOOTER //
// ./src/pages/consultas/ConsultaExtratoCnis.jsx